import { audiobooksData } from '../../../mocks/audiobooks';

const AudiobooksList = () => {
  return (
    <section className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="space-y-16">
          {audiobooksData.map((audiobook) => (
            <div
              key={audiobook.id}
              className="bg-white rounded-3xl overflow-hidden hover:shadow-lg transition-shadow duration-300 border border-gray-100"
            >
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-0">
                {/* Audiobook Cover */}
                <div className="relative bg-gradient-to-br from-[#F5E6D3] to-[#E8D4B8] p-12 flex items-center justify-center">
                  <div className="relative">
                    <img
                      src={audiobook.coverImage}
                      alt={audiobook.title}
                      className="w-full max-w-xs h-auto object-contain drop-shadow-2xl"
                    />
                    {/* Audio Wave Decoration */}
                    <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 flex gap-1">
                      {[...Array(5)].map((_, i) => (
                        <div
                          key={i}
                          className="w-1 bg-[#D4AF37] rounded-full animate-pulse"
                          style={{
                            height: `${(i % 3 + 1) * 8}px`,
                            animationDelay: `${i * 0.1}s`,
                          }}
                        ></div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Audiobook Details */}
                <div className="lg:col-span-2 p-8 md:p-10">
                  <div className="flex items-start justify-between mb-5">
                    <div>
                      <div className="flex items-center gap-3 mb-3">
                        <p className="text-xs text-[#D4AF37] font-semibold uppercase tracking-widest">
                          Audiobook
                        </p>
                      </div>
                      <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#1B3A52] mb-3 leading-tight">
                        {audiobook.title}
                      </h2>
                      {audiobook.subtitle && (
                        <p className="text-base text-gray-600 italic mb-3">{audiobook.subtitle}</p>
                      )}
                    </div>
                  </div>

                  {/* Audiobook Info */}
                  <div className="flex flex-wrap gap-5 mb-6 pb-6 border-b border-gray-200">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-[#F5E6D3] rounded-full flex items-center justify-center">
                        <i className="ri-time-line text-lg text-[#1B3A52]"></i>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">Duration</p>
                        <p className="text-sm font-semibold text-[#1B3A52]">{audiobook.duration}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-[#F5E6D3] rounded-full flex items-center justify-center">
                        <i className="ri-file-list-line text-lg text-[#1B3A52]"></i>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">Format</p>
                        <p className="text-sm font-semibold text-[#1B3A52]">{audiobook.format}</p>
                      </div>
                    </div>
                  </div>

                  <p className="text-sm text-gray-700 leading-relaxed mb-8">
                    {audiobook.description}
                  </p>

                  {/* Purchase Button */}
                  {audiobook.purchaseLink ? (
                    <a
                      href={audiobook.purchaseLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full bg-[#1B3A52] text-white px-7 py-3 rounded-full text-base font-medium hover:bg-[#2a5270] transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-shopping-cart-line text-xl"></i>
                      Purchase Audiobook
                    </a>
                  ) : (
                    <div className="w-full border-2 border-dashed border-[#D4AF37] text-[#1B3A52] px-7 py-3 rounded-full text-base font-medium flex items-center justify-center gap-3 whitespace-nowrap bg-[#FDF8EE]">
                      <i className="ri-time-line text-xl text-[#D4AF37]"></i>
                      Available Soon
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-24 text-center bg-gradient-to-br from-[#1B3A52] to-[#2a5270] rounded-3xl p-10 md:p-12">
          <div className="w-14 h-14 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-5">
            <i className="ri-volume-up-line text-2xl text-white"></i>
          </div>
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-5">
            Audiobooks Coming Soon
          </h3>
          <p className="text-base text-white/90 mb-6 max-w-2xl mx-auto">
            These powerful teachings will soon be available in audio format. In the meantime, explore the print versions of these life-changing books.
          </p>
          <a
            href="/books"
            className="inline-block bg-[#D4AF37] text-[#1B3A52] px-8 py-3 rounded-full text-base font-medium hover:bg-[#c49d2f] transition-all whitespace-nowrap cursor-pointer"
          >
            View Print Books →
          </a>
        </div>
      </div>
    </section>
  );
};

export default AudiobooksList;
